import { render, staticRenderFns } from "./BoostersInHub.vue?vue&type=template&id=3a295400"
import script from "./BoostersInHub.vue?vue&type=script&lang=js"
export * from "./BoostersInHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports